import { Stack } from '@backyard-ui/core';

import { useProductStore } from '@/presenters/store/catalog/product';

import { styles } from './Characteristics.styles';
import { Medias } from './Medias';
import { Stamps } from './Stamps';

export default function Characteristics() {
  const classNames = styles({ variant: 'default' });

  const characteristics = useProductStore(
    (store) => store.product.characteristics
  );

  const disclaimer = useProductStore((store) => store.product.disclaimer);

  if (characteristics.length <= 0 && !disclaimer) {
    return null;
  }

  return (
    <Stack direction={{ initial: 'column', md: 'row' }}>
      <table className={classNames.table()}>
        <tbody>
          {characteristics.map(({ name, value }, i) => (
            <tr key={i} className={classNames.tr({})}>
              <th className={classNames.th()}>
                <strong>{name}</strong>
              </th>
              <td className={classNames.td()}>{value}</td>
            </tr>
          ))}
          {disclaimer && (
            <tr className={classNames.tr({ variant: 'warn' })}>
              <th className={classNames.th()}>
                <strong>Atenção</strong>
              </th>
              <td className={classNames.td()}>{disclaimer}</td>
            </tr>
          )}
        </tbody>
      </table>

      <Stack direction="column">
        <Medias />
        <Stamps />
      </Stack>
    </Stack>
  );
}
